import angular from 'angular';
import onboardingAsic from './onboardingAsic';

export default angular
  .module('components.onboardingAsic', [])
  .component('onboardingAsic', onboardingAsic).name;
